import script from "./WhyJoinSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyJoinSection.vue?vue&type=script&setup=true&lang=js"

import "./WhyJoinSection.vue?vue&type=style&index=0&id=02625f9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02625f9a"]])

export default __exports__